// mechanicalEngineeringData.js

const mechanicalEngineeringData = [
    {
      section: "Mathematics & Natural Sciences",
      subtotal: "35",
      courses: [
        { id: "MATH32", code: "MATH 32", title: "Calculus I", credit: 4 },
        { id: "MATH34", code: "MATH 34", title: "Calculus II", credit: 4 },
        { id: "MATH42", code: "MATH 42", title: "Calculus III", credit: 4 },
        { id: "MATH51", code: "MATH 51", title: "Differential Equations", credit: 4 },
        { id: "CHEM1", code: "CHEM 1", title: "Gen. Chem. I w/ lab", credit: 5 },
        { id: "PHY11", code: "PHY 11", title: "Gen. Physics I w/ lab", credit: 5 },
        { id: "BIOCHEM_PHY_a", code: "BIO-CHEM-PHY Elective (a)", title: "", credit: "3-5" },
        { id: "ProbStats_Num_b", code: "Prob., Stats., or Num. (b)", title: "", credit: "3-4" },
      ],
    },
    {
      section: "Engineering Fundamentals",
      subtotal: "7",
      courses: [
        { id: "EN1", code: "EN 1", title: "Applications in Eng.", credit: 3 },
        {
          id: "ES2_CS11",
          code: "ES 2 or CS 11",
          title: "Intro. Comp. in Eng. or Intro. Comp. Sci.",
          credit: 4,
        },
      ],
    },
    {
      section: "HASS Electives",
      subtotal: "24",
      courses: [
        { id: "ENG1_HASS", code: "ENG 1", title: "Expos. Writing or ENG 3", credit: 3 },
        {
          id: "Humanities_Elec_c",
          code: "Humanities Elective (c)",
          title: "",
          credit: "≥3",
        },
        {
          id: "SocialSci_Elec_d",
          code: "Social Science Elective (d)",
          title: "",
          credit: "≥3",
        },
      ],
    },
    {
      section: "Materials & Manufacturing",
      subtotal: "7",
      courses: [
        { id: "ME10", code: "ME 10", title: "Mat. & Manufac. I", credit: 4 },
        { id: "ME11", code: "ME 11", title: "Mat. & Manufac. II", credit: 3 },
      ],
    },
    {
      section: "Mechanics",
      subtotal: "6",
      courses: [
        { id: "ME20", code: "ME 20", title: "Mechanics I", credit: 3 },
        { id: "ME21", code: "ME 21", title: "Mechanics II", credit: 3 },
      ],
    },
    {
      section: "Electronics & Controls",
      subtotal: "7",
      courses: [
        { id: "ME30", code: "ME 30", title: "Electronics & Controls I", credit: 4 },
        { id: "ME31", code: "ME 31", title: "Electronics & Controls II", credit: 3 },
      ],
    },
    {
      section: "Engineering Design",
      subtotal: "7",
      courses: [
        { id: "ME40", code: "ME 40", title: "Engineering Design I", credit: 4 },
        { id: "ME41", code: "ME 41", title: "Engineering Design II", credit: 3 },
      ],
    },
    {
      section: "Thermal Fluid Systems",
      subtotal: "7",
      courses: [
        { id: "ME50", code: "ME 50", title: "Thermal Fluid Sys. I", credit: 3 },
        { id: "ME51", code: "ME 51", title: "Thermal Fluid Sys. II", credit: 4 },
      ],
    },
    {
      section: "Program Electives",
      subtotal: "21",
      courses: [
        { id: "Tech_Elec_f1", code: "Technical Elective (f)", title: "", credit: "≥3" },
        { id: "Tech_Elec_f2", code: "Technical Elective (f)", title: "", credit: "≥3" },
        { id: "ME_or_Tech", code: "ME or Technical Elective (f or g)", title: "", credit: "≥3" },
        { id: "ME_Elec_g1", code: "ME Elective (g)", title: "", credit: "≥3" },
        { id: "ME_Elec_g2", code: "ME Elective (g)", title: "", credit: "≥3" },
        { id: "ME_Elec_g3", code: "ME Elective (g)", title: "", credit: "≥3" },
        { id: "ME_Elec_g4", code: "ME Elective (g)", title: "", credit: "≥3" },
      ],
    },
    {
      section: "Engineering Synthesis",
      subtotal: "7",
      courses: [
        { id: "ME70", code: "ME 70", title: "Instrum. & Experiments", credit: 4 },
        { id: "ME74", code: "ME 74", title: "Senior Design Project", credit: 3 },
      ],
    },
  ];
  
  export default mechanicalEngineeringData;
  